import { BaseError } from "@aa-sdk/core";
export class NotAuthenticatedError extends BaseError {
    constructor() {
        super([
            "Signer not authenticated",
            "Please authenticate to use this signer",
        ].join("\n"), {
            docsPath: "/signers/alchemy-signer/introduction.html",
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "NotAuthenticatedError"
        });
    }
}
export class OAuthProvidersError extends BaseError {
    constructor() {
        super("OAuth providers not found", {
            docsPath: "/react/getting-started",
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "OAuthProvidersError"
        });
    }
}
export class MfaRequiredError extends BaseError {
    constructor(multiFactors) {
        super("MFA is required for this user");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "MfaRequiredError"
        });
        Object.defineProperty(this, "multiFactors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.multiFactors = multiFactors;
    }
}
//# sourceMappingURL=errors.js.map